export class CustomerRegistration {
    userRegisterId: number;
    registrationType: any;
    registrationCode: string;
    reportingOfficialId: any;
    agencyCode: string;
    bureauCode: string;
    firstName: string;
    lastName: string;
    middleInitial: string;
    title: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateId: string;
    zip: string;
    zipSuffix: string;
    countryId: string;
    phone: string;
    phoneExtension: string;
    email: string;
    accessRequested: any;
    registrationStatus: any;
    rejectReason: string;
    confirmDate: any = 0;
    createdDate: any;
    updateProgram: string;
    updateId: any;
    updateDate: any;
    agencyName: string;
    agencyBureauName: string;
    stateName: string;
    countryName: string;
}
